import { mergeProps } from "../slot";

/**
 * Merges the props a TextInput maps onto its element over the ones it passes
 * through: the caller's remaining shared props, and anything a parent's Slot
 * injects. A mapping the primitive sets wins, an unset one (`undefined`)
 * leaves a passed-through value alone, and same-named handlers both run.
 *
 * `className` and `style` are combined only when both sides set them. Slot's
 * merge would otherwise send a lone className through tailwind-merge, which
 * drops classes it sees as conflicting (`leading-none` before `text-[24px]`).
 */
export function mergeMapped(rest: Record<string, unknown>, mapped: Record<string, unknown>) {
  const set = Object.fromEntries(Object.entries(mapped).filter(([, value]) => value !== undefined));
  const merged = mergeProps(rest, set);
  for (const key of ["className", "style"]) {
    if (rest[key] === undefined && key in set) merged[key] = set[key];
    else if (set[key] === undefined && key in rest) merged[key] = rest[key];
  }
  return merged;
}
